// ✅ FRAME SYSTEM - Constants
// Bu faylı constants və ya utils folder-ə qoy

export const FRAMES = {
    // Default frames (hamı istifadə edə bilər)
    default: [
        {
            id: 1,
            name: 'Classic',
            type: 'default',
            className: 'border-4 border-gray-400 rounded-full',
            isPremium: false,
            isAnimated: false,
            description: 'Klassik çərçivə'
        },
        {
            id: 2,
            name: 'Blue',
            type: 'default',
            className: 'border-4 border-blue-500 rounded-full shadow-lg shadow-blue-500/50',
            isPremium: false,
            isAnimated: false,
            description: 'Mavi çərçivə'
        },
        {
            id: 3,
            name: 'Gold',
            type: 'default',
            className: 'border-4 border-yellow-500 rounded-full shadow-lg shadow-yellow-500/50',
            isPremium: false,
            isAnimated: false,
            description: 'Qızıl çərçivə'
        },
        {
            id: 4,
            name: 'Silver',
            type: 'default',
            className: 'border-4 border-gray-300 rounded-full shadow-lg shadow-gray-300/50',
            isPremium: false,
            isAnimated: false,
            description: 'Gümüş çərçivə'
        },
        {
            id: 5,
            name: 'Green',
            type: 'default',
            className: 'border-4 border-green-500 rounded-full shadow-lg shadow-green-500/50',
            isPremium: false,
            isAnimated: false,
            description: 'Yaşıl çərçivə'
        }
    ],
    
    // Premium frames (achievement və ya admin grant)
    premium: [
        {
            id: 6,
            name: 'Bronze Star',
            type: 'premium',
            className: 'border-4 rounded-full animate-bronze-glow',
            isPremium: true,
            isAnimated: true,
            unlockRequirement: '10 satış',
            description: 'Bürünc ulduz - 10 satış'
        },
        {
            id: 7,
            name: 'Silver Glow',
            type: 'premium',
            className: 'border-4 rounded-full animate-silver-glow',
            isPremium: true,
            isAnimated: true,
            unlockRequirement: '50 satış',
            description: 'Gümüş parıltı - 50 satış'
        },
        {
            id: 8,
            name: 'Gold Crown',
            type: 'premium',
            className: 'border-4 rounded-full animate-gold-glow',
            isPremium: true,
            isAnimated: true,
            unlockRequirement: '100 satış',
            description: 'Qızıl tac - 100 satış'
        },
        {
            id: 9,
            name: 'Diamond Shine',
            type: 'premium',
            className: 'border-4 rounded-full animate-diamond-shine',
            isPremium: true,
            isAnimated: true,
            unlockRequirement: '500 satış',
            description: 'Almaz parıltısı - 500 satış'
        },
        {
            id: 10,
            name: 'Top Rated',
            type: 'premium',
            className: 'border-4 rounded-full animate-rainbow-glow',
            isPremium: true,
            isAnimated: true,
            unlockRequirement: '4.5+ reytinq',
            description: 'Ən yüksək reytinqli - 4.5⭐'
        },
        // ── ✨ Premium Frame Set v2 ──
        {
            id: 11,
            name: 'Neon Orbit',
            type: 'premium',
            className: 'border-4 rounded-full animate-neon-orbit',
            isPremium: true,
            isAnimated: true,
            unlockRequirement: 'Admin',
            description: 'Neon orbit — parlaq mavi/bənövşəyi'
        },
        {
            id: 12,
            name: 'Crystal Diamond',
            type: 'premium',
            className: 'border-4 rounded-full animate-crystal-diamond',
            isPremium: true,
            isAnimated: true,
            unlockRequirement: 'Admin',
            description: 'Kristal almaz parıltısı'
        },
        {
            id: 13,
            name: 'Fire Crown',
            type: 'premium',
            className: 'border-4 rounded-full animate-fire-crown',
            isPremium: true,
            isAnimated: true,
            unlockRequirement: 'Admin',
            description: 'Alov tacı — qırmızı/narıncı titrəyiş'
        },
        {
            id: 14,
            name: 'Cyber Pulse',
            type: 'premium',
            className: 'border-4 rounded-full animate-cyber-pulse',
            isPremium: true,
            isAnimated: true,
            unlockRequirement: 'Admin',
            description: 'Kiber nəbz — neon mavi/çəhrayı'
        },
        {
            id: 15,
            name: 'Galaxy Ring',
            type: 'premium',
            className: 'border-4 rounded-full animate-galaxy-ring',
            isPremium: true,
            isAnimated: true,
            unlockRequirement: 'Admin',
            description: 'Qalaktika halqası'
        },
        {
            id: 16,
            name: 'Royal Gold',
            type: 'premium',
            className: 'border-4 rounded-full animate-royal-gold',
            isPremium: true,
            isAnimated: true,
            unlockRequirement: 'Admin',
            description: 'Royal qızıl — lüks parıltı'
        },
        // ── ✨ Premium Frame Pack v3 (Phase 4) ──
        { id: 17, name: 'Ice Crystal',     type: 'premium', rarity: 'rare',       className: 'border-4 rounded-full animate-ice-crystal',     isPremium: true, isAnimated: true, unlockRequirement: 'Admin', description: 'Buz kristalı' },
        { id: 18, name: 'Electric Storm',  type: 'premium', rarity: 'epic',       className: 'border-4 rounded-full animate-electric-storm',  isPremium: true, isAnimated: true, unlockRequirement: 'Admin', description: 'Elektrik fırtınası' },
        { id: 19, name: 'Hologram Shift',  type: 'premium', rarity: 'legendary',  className: 'border-4 rounded-full animate-hologram',        isPremium: true, isAnimated: true, unlockRequirement: 'Admin', description: 'Holoqram' },
        { id: 20, name: 'Glitch Matrix',   type: 'premium', rarity: 'epic',       className: 'border-4 rounded-full animate-glitch-matrix',   isPremium: true, isAnimated: true, unlockRequirement: 'Admin', description: 'Glitch matrisi' },
        { id: 21, name: 'Toxic Green',     type: 'premium', rarity: 'rare',       className: 'border-4 rounded-full animate-toxic-green',     isPremium: true, isAnimated: true, unlockRequirement: 'Admin', description: 'Toksik yaşıl' },
        { id: 22, name: 'Lava Burst',      type: 'premium', rarity: 'epic',       className: 'border-4 rounded-full animate-lava-burst',      isPremium: true, isAnimated: true, unlockRequirement: 'Admin', description: 'Lava partlayışı' },
        { id: 23, name: 'Frost Halo',      type: 'premium', rarity: 'rare',       className: 'border-4 rounded-full animate-frost-halo',      isPremium: true, isAnimated: true, unlockRequirement: 'Admin', description: 'Şaxta halosu' },
        { id: 24, name: 'Shadow Void',     type: 'premium', rarity: 'epic',       className: 'border-4 rounded-full animate-shadow-void',     isPremium: true, isAnimated: true, unlockRequirement: 'Admin', description: 'Kölgə boşluğu' },
        { id: 25, name: 'Pixel Retro',     type: 'premium', rarity: 'rare',       className: 'border-4 rounded-full animate-pixel-retro',     isPremium: true, isAnimated: true, unlockRequirement: 'Admin', description: 'Piksel retro' },
        { id: 26, name: 'Sakura Glow',     type: 'premium', rarity: 'rare',       className: 'border-4 rounded-full animate-sakura-glow',     isPremium: true, isAnimated: true, unlockRequirement: 'Admin', description: 'Sakura parıltısı' },
        { id: 27, name: 'Money Rain',      type: 'premium', rarity: 'epic',       className: 'border-4 rounded-full animate-money-rain',      isPremium: true, isAnimated: true, unlockRequirement: 'Admin', description: 'Pul yağışı' },
        { id: 28, name: 'VIP Crown',       type: 'premium', rarity: 'admin_only', className: 'border-4 rounded-full animate-vip-crown',       isPremium: true, isAnimated: true, unlockRequirement: 'Admin', description: 'VIP tac' },
        { id: 29, name: 'Dragon Flame',    type: 'premium', rarity: 'legendary',  className: 'border-4 rounded-full animate-dragon-flame',    isPremium: true, isAnimated: true, unlockRequirement: 'Admin', description: 'Əjdaha alovu' },
        { id: 30, name: 'Thunder Blue',    type: 'premium', rarity: 'epic',       className: 'border-4 rounded-full animate-thunder-blue',    isPremium: true, isAnimated: true, unlockRequirement: 'Admin', description: 'Göy şimşək' },
        { id: 31, name: 'Emerald Shield',  type: 'premium', rarity: 'rare',       className: 'border-4 rounded-full animate-emerald-shield',  isPremium: true, isAnimated: true, unlockRequirement: 'Admin', description: 'Zümrüd qalxan' },
        { id: 32, name: 'Rainbow Prism',   type: 'premium', rarity: 'legendary',  className: 'border-4 rounded-full animate-rainbow-prism',   isPremium: true, isAnimated: true, unlockRequirement: 'Admin', description: 'Göy qurşağı prizma' },
        { id: 33, name: 'Black Diamond',   type: 'premium', rarity: 'admin_only', className: 'border-4 rounded-full animate-black-diamond',   isPremium: true, isAnimated: true, unlockRequirement: 'Admin', description: 'Qara almaz' },
        { id: 34, name: 'Seasonal Winter', type: 'premium', rarity: 'seasonal',   className: 'border-4 rounded-full animate-seasonal-winter', isPremium: true, isAnimated: true, unlockRequirement: 'Event', description: 'Mövsümi qış' }
    ]
};

// ✅ Get frame by ID
export const getFrameById = (frameId) => {
    const allFrames = [...FRAMES.default, ...FRAMES.premium];
    return allFrames.find(frame => frame.id === frameId) || FRAMES.default[0];
};

// ✅ Phase 3 — yararlı (usable) aktiv frame: revoked/expired DEYİL.
// Köhnə data ilə uyğun: unlockedFrames yoxdursa activeFrame yenə göstərilir.
// Hər səhifədə (SellerCard, ShopPage, Spotlight, məhsul detalı) eyni məntiq.
export const getUsableSellerFrame = (seller) => {
    if (!seller) return getFrameById(1);
    const shop = seller.shopInfo || seller;
    const active = shop?.activeFrame || seller.activeFrame;
    const frameId = active?.frameId;
    if (!frameId) return getFrameById(1);

    const unlocked = shop?.unlockedFrames || seller.unlockedFrames;
    if (Array.isArray(unlocked) && unlocked.length) {
        const ent = unlocked.find(f => f.frameId === frameId);
        if (ent) {
            if (ent.status === 'revoked') return getFrameById(1);
            if (ent.expiresAt && new Date(ent.expiresAt).getTime() < Date.now()) return getFrameById(1);
        }
        // ent tapılmasa belə activeFrame-i göstər (köhnə data uyğunluğu)
    }
    return getFrameById(frameId);
};

// ✅ Hərəkətli avatar icazəsi etibarlıdırmı (access + expiry)
export const hasUsableAnimatedAvatar = (seller) => {
    const a = seller?.animatedAvatar;
    if (!a?.access) return false;
    if (a.expiresAt && new Date(a.expiresAt).getTime() < Date.now()) return false;
    return true;
};

// ✅ Get all frames
export const getAllFrames = () => {
    return [...FRAMES.default, ...FRAMES.premium];
};

// ✅ Check if frame is premium
export const isFramePremium = (frameId) => {
    return FRAMES.premium.some(frame => frame.id === frameId);
};

// ✅ Achievement requirements
export const ACHIEVEMENTS = {
    FIRST_SALE: {
        id: 'first_sale',
        title: 'İlk Satış',
        description: 'İlk məhsulunuzu satdınız!',
        requirement: 1,
        reward: null
    },
    SALES_10: {
        id: 'sales_10',
        title: 'Bürünc Satıcı',
        description: '10 məhsul satdınız',
        requirement: 10,
        reward: { frameId: 6, frameName: 'Bronze Star' }
    },
    SALES_50: {
        id: 'sales_50',
        title: 'Gümüş Satıcı',
        description: '50 məhsul satdınız',
        requirement: 50,
        reward: { frameId: 7, frameName: 'Silver Glow' }
    },
    SALES_100: {
        id: 'sales_100',
        title: 'Qızıl Satıcı',
        description: '100 məhsul satdınız',
        requirement: 100,
        reward: { frameId: 8, frameName: 'Gold Crown' }
    },
    SALES_500: {
        id: 'sales_500',
        title: 'Almaz Satıcı',
        description: '500 məhsul satdınız',
        requirement: 500,
        reward: { frameId: 9, frameName: 'Diamond Shine' }
    },
    TOP_RATED: {
        id: 'top_rated',
        title: 'Ən Yaxşı Reytinq',
        description: '4.5+ reytinq və 10+ rəy',
        requirement: { rating: 4.5, reviews: 10 },
        reward: { frameId: 10, frameName: 'Top Rated' }
    }
};

export default FRAMES;